const EVENTS = {
  NAV_RENDER_PREVIOUS: "NAV_RENDER_PREVIOUS",
  NAV_RERENDER: "NAV_RERENDER",
  NAV_RENDER: "NAV_RENDER",

  SHOW_TASK_DIALOG: "SHOW_TASK_DIALOG",

  // Nav (Pages)
  HERO_PAGE: "HERO_PAGE",
  REMOVE_HERO_PAGE: "REMOVE_HERO_PAGE",
  TODAY: "TODAY",
  SEARCH: "SEARCH",
  CATEGORY: "CATEGORY",
  SUBCATEGORY: "SUBCATEGORY"
};

export default EVENTS;
